// extracted by mini-css-extract-plugin
export default {"appHeader":"AppHeader_appHeader__t4Wgi","logo":"AppHeader_logo__plH7a"};